import { apiClient } from '../client';
import { API_ENDPOINTS } from '@/utils/constants';
import type { User } from '@/types';

// 获取用户信息
export const getUserProfile = async (): Promise<User> => {
  const response = await apiClient.get<User>(API_ENDPOINTS.USER.PROFILE);
  return response.data;
};

// 更新用户信息
export const updateUserProfile = async (data: Partial<User>): Promise<User> => {
  const response = await apiClient.put<User>(API_ENDPOINTS.USER.UPDATE_PROFILE, data);
  return response.data;
};

// 修改密码
export const changePassword = async (data: {
  currentPassword: string;
  newPassword: string;
}): Promise<void> => {
  await apiClient.post(API_ENDPOINTS.USER.CHANGE_PASSWORD, data);
};